import React from "react";
import {InfoPageAccordion} from "../contenful/types";
import './InfoPageAccordionComponent.scss';
import {BLOCKS} from '@contentful/rich-text-types';
import {renderContentAsComponent} from "../contentutils";


export const richTextOptions = {
    renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node:any) => {
            const { title, description, file } = node.data.target.fields;
            const mimeType = file.contentType;
            const mimeGroup = mimeType.split('/')[0];

            if(mimeGroup == 'image') {
                return <img
                    title={ title ? title : null}
                    alt={description ?  description : "info"}
                    src={file.url}
                />;
            } else {
                return <span style={{backgroundColor: 'red', color: 'white'}}> {mimeType} embedded asset </span>;
            }
        }
    }
};


interface Props {
    section: InfoPageAccordion;
    mobile: boolean;
    infoPageId?: string;
    onClick?: () => void;
    index?: any;
}

const InfoPageAccordionComponent = (props: Props) => {
    return (
            <div className="card" id={props.index}>
                <div className="card-header" onClick={props.onClick}>
                    <h4 className="mb-0 header">
                        <button className="btn header-btn title">
                            {props.section.title}
                        </button>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" className={`arrow-accordion`} id={`arrow-${props.index}`}
                            width="15px" height="15px" viewBox="-36.5 91.5 648.5 398" enableBackground="new -36.5 91.5 648.5 398">
                            <path fill="#FFFFFF" d="M599.01,143.18l-36.22-36.37l-13.33-13.39l-12.73,13.96L287.76,380.57L38.77,107.39L26.04,93.42l-13.33,13.4
	                            l-36.22,36.4l-12.09,12.15l11.55,12.67l279.1,306.24l0.27,0.29l0.28,0.28c8.11,8.15,19.03,12.64,30.75,12.64
	                            c0.46,0,0.93-0.01,1.4-0.02c0.47,0.01,0.94,0.02,1.4,0.02c11.72,0,22.64-4.49,30.74-12.64l0.28-0.28l0.26-0.29l279.13-306.27
	                            l11.55-12.68L599.01,143.18z"/>
                        </svg>
                    </h4>
                </div>
                <div className={`expandable-accordion`} id={`expandable-${props.infoPageId}-${props.index}`} >
                    <div className="card-body">
                        <div className="card-body-content">
                            {
                                renderContentAsComponent(props.section.text as any, richTextOptions)
                            }
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default InfoPageAccordionComponent;